import { render, staticRenderFns } from "./FuneralGuide.vue?vue&type=template&id=1184ac08&scoped=true&"
import script from "./FuneralGuide.vue?vue&type=script&lang=js&"
export * from "./FuneralGuide.vue?vue&type=script&lang=js&"
import style0 from "./FuneralGuide.vue?vue&type=style&index=0&id=1184ac08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184ac08",
  null
  
)

export default component.exports